import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const AICallingAgent = () => {
  return (
    <div className={classNames(styles.content)}>
      <div className={classNames(styles.wrapIcon)}>
        <Icon icon={'stars'} fontSize={16} />
      </div>
      <Typography
        tag={'div'}
        variant={'body-sm-regular'}
        color={'var(--content-primary-primary)'}
        ariaLabel={'aiCallingAgent'}
      >
        Enrolled in AI Calling Agent
      </Typography>
    </div>
  )
}
